<template>
  <section class="auth-section" :class="{ superadmin: superadmin }">
    <div class="row no-gutters h-100">
      <div class="col-lg-5">
        <AuthLeftPart/>
      </div>
      <div class="col-lg-6">
        <div class="right-part h-100 d-flex justify-content-center align-items-center">
          <div class="right__content">
            <h1 class="mb-3" v-if="!superadmin">{{ $t('authorize_in_system') }}</h1>
            <h1 class="mb-3" v-if="superadmin">Superadmin</h1>
            <p v-if="!superadmin && !flutterApp"
               class="auth__note mt-3 mb-4">
              Хотите стать пользователем нашей системы? Пожалуйста, обратитесь в наш <a href="https://dentist-plus.com" target="_blank" rel="noopener noreferrer">отдел продаж</a>.
            </p>
            <InputGroup :label="$t('login')"
                        type="text"
                        @enter="login()"
                        v-model="form.username"/>
            <ValidationError validation-id="username"/>
            <InputGroup :label="$t('password')"
                        v-model="form.password"
                        type="password"
                        @enter="login()"/>
            <ValidationError v-if="form.password.length < 1" validation-id="password"/>
            <div class="form-group text-right mt-md-4 pt-3">
              <button @click="login()"
                      :disabled="loading"
                      class="btn-themed login-btn">{{ $t('signin') }}
              </button>
            </div>
            <div v-if="errors && errors.general" class="alert alert-danger py-2">
              {{ errors.general.join(', ') }}
            </div>
            <div class="text-right mt-2" v-if="!superadmin">
              <router-link class="small" to="/forgot-password">{{ $t('forgot_password') }}</router-link>
            </div>
            <p class="disclaimer text-muted mt-5" v-if="!superadmin">{{ $t('login_disclaimer') }}</p>
          </div>
        </div>
      </div>
    </div>
    <TwoFactorCodeInputModal @codeEntered="modalResolve"
                             :allow-for-backup="true"/>

  </section>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup"
import { useStore} from "vuex"
import ValidationError from "@/components/form/ValidationError"
import {hideHelpDeskeddy} from "@/services/helpDeskeddy.helper"
import {computed, getCurrentInstance, onBeforeMount, onMounted, reactive, ref } from "vue"
import {useHead} from "@unhead/vue"
import {useRoute, useRouter} from "vue-router"
import {copyObject} from "@/extensions/prototypes/prototypes"
import TwoFactorCodeInputModal from "@/components/parts/staff/TwoFactorCodeInputModal.vue"
import AuthLeftPart from "@/components/parts/auth/AuthLeftPart.vue"
import {isDocPro} from "@/services/auth.helper"

const store = useStore()
const router = useRouter()
const route = useRoute()
let i18n = null
let bvModal = null
const title = ref('')

useHead({
  title: () => title.value,
})

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  i18n = instance?.ctx?.$i18n
  title.value = i18n.t('authorization')
  bvModal = instance?.ctx?._bv__modal
})

const form = reactive({
  username: "",
  password: "",
})
const modalResolve = ref(() => {})

onMounted(() => {
  store.commit('setError', {})
  hideHelpDeskeddy()
})

const loading = computed(() => store.state.dom.loading)
const errors = computed(() => store.state.auth.errors)
const flutterApp = computed(() => store.state.auth.flutterApp)
const urlAfterLogin = computed(() => store.state.auth.urlAfterLogin)
const superadmin = computed(() => route.name === 'AdminLogin')

const login = async (code = null) => {
  let params = copyObject(form)
  params.superadmin = superadmin.value
  params.isDocPro = isDocPro()
  params.two_factor_code = code
  try {
    const response = await store.dispatch('login', params)
    if(response.requires_2fa && !code) {
      store.commit('setError', {})
      const codeEntered = await openTwoFactor()
      if(codeEntered) {
        await login(codeEntered)
      }
      return
    }
    if(response.must_change_password) {
      router.push('/change-password').catch(()=>{})
      return
    }
    if(urlAfterLogin.value) {
      router.push(urlAfterLogin.value).then(() => {
        store.commit('setUrlAfterLogin', null)
      }).catch(()=>{})
      return
    }
    router.push(superadmin.value ? '/superadmin' : '/').catch(()=>{})
  } catch (error) {
    console.error('Login error:', error)
  }
}

const openTwoFactor = async () => {
  bvModal.show('two-factor-code-input-modal')
  return new Promise((resolve) => {
    modalResolve.value = resolve
  })
}
</script>

<style lang="scss" scoped>
.login-btn {
  min-width: 200px;
  width: 100%;
}
.disclaimer {
  font-size: 81%;
}
</style>

